import type {SyncRoute} from 'src/rerouter';
import {redirect} from './utils';


export const workflowJourneyRedirect: SyncRoute = {
  path: '(analytics/)workflow(s)',
  element: redirect((location) => ({
    ...location,
    pathname: location.pathname
      .replace('workflow', 'journey')
      .replace('event', 'touchpoint'),
  })),
};
